import { Action } from '@ngrx/store';
import { CwcTimeSlot } from './../../models/cwc-time-slot.model';

export enum ActionTypes {
    FORMAT_DATA_FOR_CALENDAR_VIEW = '[MOO DCO SCHEDULE] Format data for calendar view',
    PUSH_TIME_SLOTS = '[MOO DCO SCHEDULE] Push time slots',
    FETCH_SCHEDULE_DAYS = '[MOO DCO SCHEDULE] Fetch Schedule Days',
    FETCH_SCHEDULE_DAYS_SUCCESS = '[MOO DCO SCHEDULE] Fetch Schedule Days Success',
    FETCH_SCHEDULE_DAYS_ERROR = '[MOO DCO SCHEDULE] Fetch Schedule Days Error',
}

export class FormatDataForCalendarView implements Action {
    readonly type = ActionTypes.FORMAT_DATA_FOR_CALENDAR_VIEW;
    constructor(public payload: { formId: number }) { }
}

export class PushTimeSlots implements Action {
    readonly type = ActionTypes.PUSH_TIME_SLOTS;
    constructor(public payload: { formId: number, timeslots: CwcTimeSlot[] }) { }
}

export class FetchScheduleDays implements Action {
    readonly type = ActionTypes.FETCH_SCHEDULE_DAYS;
    constructor(public payload: { formId: number, requestDatetime: moment.Moment }) { }
}

export class FetchScheduleDaysSuccess implements Action {
    readonly type = ActionTypes.FETCH_SCHEDULE_DAYS_SUCCESS;
    constructor(public payload: { formId: number, response: CwcTimeSlot[] }) { }
}

export class FetchScheduleDaysError implements Action {
    readonly type = ActionTypes.FETCH_SCHEDULE_DAYS_ERROR;
    constructor(public payload: { formId: number, error: any }) { }
}

export type Actions =
    | FormatDataForCalendarView
    | PushTimeSlots
    | FetchScheduleDays
    | FetchScheduleDaysSuccess
    | FetchScheduleDaysError
    ;
